const selector = (state) => state.get('pagesColumns');

export const inSegmentManagementSelector = (state) => selector(state).get('inSegmentManagement');

export const routerColumnSetIdSelector = (state) => selector(state).get('routerColumnSetId');

export const selectedColumnsSelector = (state) => selector(state).get('selectedColumns');
